import React from 'react';
import { Select, MenuItem, makeStyles } from '@material-ui/core';
import { RANGE_OPTIONS, RangeValue } from '../../constants/product.constant';

const useStyles = makeStyles(() => ({
  select: { backgroundColor: '#fff', minWidth: 150 },
}));

type Props = { value: RangeValue; onChange: (v: RangeValue) => void };

const RangeSelector: React.FC<Props> = ({ value, onChange }) => {
  const classes = useStyles();
  return (
    <Select
      className={classes.select}
      variant="outlined"
      margin="dense"
      value={value}
      onChange={(e) => onChange(e.target.value as RangeValue)}
    >
      {RANGE_OPTIONS.map((opt) => (
        <MenuItem key={String(opt.value)} value={opt.value}>
          {opt.label}
        </MenuItem>
      ))}
    </Select>
  );
};

export default RangeSelector;
